import React                    from 'react';
import connect                  from 'react-redux/es/connect/connect';
import { bindActionCreators }   from 'redux';
import { setCurrentRestaurant } from '../../store/actions/restaurant';

class RestaurantContext extends React.Component {
    componentDidMount() {
        const { match: { params: { restaurantId } } } = this.props;
        this.props.onRestaurantIdUpdated(restaurantId);
    }

    componentDidUpdate(prevProps) {
        const { match: { params: { restaurantId } } } = this.props;
        if(this.props.restaurantId !== restaurantId) {
            this.props.onRestaurantIdUpdated(restaurantId);
        }
    }

    render() {
        return (
            <React.Fragment>
                {this.props.restaurantId && this.props.children}
            </React.Fragment>
        );
    }
}


export default connect(
    state => ({
        restaurantId: state.restaurant.restaurantId
    }),
    // Actions
    dispatch => bindActionCreators({
        onRestaurantIdUpdated: setCurrentRestaurant
    }, dispatch)
)(RestaurantContext);



// WEBPACK FOOTER //
// /src/components/framework/RestaurantContext.js